'use client';

import React from 'react';
import Link from 'next/link';
import { MapPin, Car, Star, Zap } from 'lucide-react';

export default function ManaheshPackageCard() {
  return (
    <section className="py-8 lg:py-10 bg-gradient-to-r from-[#0F4C81] via-[#1a6bb5] to-[#0F4C81]">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10">
        {/* Section Label */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <Zap size={16} className="text-[#FFB703]" />
          <span className="text-[#FFB703] font-bold text-sm uppercase tracking-widest">
            Special Offer – Limited Time
          </span>
          <Zap size={16} className="text-[#FFB703]" />
        </div>

        {/* Card */}
        <Link
          href="/manimahesh-yatra"
          className="relative block cursor-pointer max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-[#FFB703] hover:scale-[1.02] transition-transform duration-300 group">
          
          {/* Glowing border animation */}
          <div className="absolute inset-0 rounded-2xl ring-4 ring-[#FFB703]/40 animate-pulse pointer-events-none" />

          {/* Hot Deal Badge */}
          <div className="absolute top-4 right-4 bg-red-500 text-white text-xs font-extrabold px-3 py-1.5 rounded-full shadow-lg z-10 animate-bounce">
            🔥 HOT DEAL
          </div>

          <div className="flex flex-col md:flex-row">
            {/* Left: Hero Image */}
            <div className="md:w-2/5 relative overflow-hidden min-h-[180px]">
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1ff5abdbc-1786026260954.png"
                alt="Shri Manimahesh Kailash peak and sacred Dal Lake in Chamba Himachal Pradesh"
                className="absolute inset-0 w-full h-full object-cover" />
              
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F4C81]/80 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <h3 className="text-lg font-extrabold leading-tight mb-0.5">Manimahesh Yatra</h3>
                <p className="text-blue-200 text-xs">Pathankot → Manimahesh Sahib</p>
                <div className="mt-2 flex items-center gap-1">
                  {[1, 2, 3, 4, 5]?.map((i) =>
                  <Star key={i} size={11} className="text-[#FFB703] fill-current" />
                  )}
                  <span className="text-xs text-blue-200 ml-1">4.9 • Top Rated</span>
                </div>
              </div>
            </div>

            {/* Right: Details */}
            <div className="md:w-3/5 p-6 flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <Car size={16} className="text-[#0F4C81]" />
                  <span className="text-sm font-semibold text-gray-600">
                    Taxi Package – One Way Fare
                  </span>
                </div>

                <h2 className="text-2xl font-extrabold text-[#0F4C81] mb-1">
                  Pathankot to Manimahesh Sahib
                </h2>
                <p className="text-gray-500 text-sm mb-4">
                  Comfortable, reliable taxi service for your sacred Manimahesh Yatra pilgrimage journey.
                </p>

                {/* Route */}
                <div className="flex items-center gap-2 mb-4 bg-blue-50 rounded-xl px-4 py-2.5">
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-2.5 h-2.5 rounded-full bg-[#00A86B]" />
                    <div className="w-0.5 h-4 bg-gray-300" />
                    <div className="w-2.5 h-2.5 rounded-full bg-red-500" />
                  </div>
                  <div className="flex flex-col gap-1">
                    <span className="text-xs font-semibold text-gray-700">Pathankot</span>
                    <span className="text-xs font-semibold text-gray-700">Manimahesh Sahib (via Bharmour)</span>
                  </div>
                  <div className="ml-auto flex items-center gap-1">
                    <MapPin size={11} className="text-gray-400" />
                    <span className="text-xs text-gray-400">~220 km</span>
                  </div>
                </div>

                {/* Inclusions */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {['AC Vehicle', 'Hill Driver', 'One Way', 'Toll Included', 'Instant Booking']?.map((item) =>
                  <span key={item} className="text-xs bg-green-50 text-green-700 border border-green-200 px-2.5 py-1 rounded-full font-medium">
                      ✓ {item}
                    </span>
                  )}
                </div>
              </div>

              {/* Price + CTA */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div>
                  <p className="text-xs text-gray-500 mb-0.5">Starting from</p>
                  <div className="flex items-baseline gap-1">
                    <span className="text-3xl font-extrabold text-[#0F4C81]">₹7,499</span>
                    <span className="text-sm text-gray-400 line-through">₹9,500</span>
                  </div>
                  <p className="text-xs text-[#00A86B] font-semibold">Hatchback • One Way</p>
                </div>
                <span className="bg-[#FFB703] hover:bg-yellow-500 text-[#0F4C81] font-extrabold text-sm px-5 py-3 rounded-xl shadow-lg transition-all duration-200 group-hover:shadow-xl">
                  Book Now →
                </span>
              </div>
            </div>
          </div>
        </Link>

        <p className="text-center text-blue-200 text-xs mt-4">
          Click to view all vehicle options &amp; book instantly online
        </p>
      </div>
    </section>);

}